module.exports = __webpack_public_path__ + "static/academy-dark-logo-f276be57ddf383ed19b643d3d85b1878.svg";